import React, { useEffect, useMemo, useState } from 'react'
// import Heading from '../../components/Heading/Heading';
import './Cart.scss'
import { useStateValue } from '../../store/state';
import { useTranslation } from "react-i18next";
import MUIDataTable from 'mui-datatables';
import ClearAll from '../../assets/images/cart/delete.svg'
import request from '../../request';
import Summary from '../../components/Summary/Summary';
import axios from 'axios';
import { browserName, browserVersion } from "react-device-detect";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory, useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify'
import { saveAs } from "file-saver";
import { ADDTOCART, BULKADDTOCART } from '../../store/Cart/Action';
import NoAddressModal from '../../components/NoAddressModal/NoAddressModal';
import Heading from '../Heading/Heading';


function Cart() {
  const { t } = useTranslation();
  const [columns, setColumns] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [{ cart, summary }, dispatch] = useStateValue();
  const [loader, setLoader] = useState(false)
  const [subTotal, setSubTotal] = useState([])
  const history = useHistory();
  const location = useLocation();
  const [excelData, setExcelData] = useState([]);
  const [showNoAddressModal, setShowNoAddressModal] = useState(false);
  const [userEmail, setUserEmail] = useState(localStorage.getItem("user") || "");

  const SPECIAL_EMAILS = ["deliverme_jagota@deliverme.co.th", "chatrath_s@jagota.com"];

  function formatToCurrency(price) {
    var outstanding = price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return outstanding?.replace(/\.(\d{1,2}).*$/, '.$1')
  }

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allAddresses = await axios({
      method: "get",
      url: `${request.getbranch}/${localStorage.getItem("userid")}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    const branchNames = allAddresses?.data?.map(branch => branch.branch_name);

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const itemsForBulkCart = new Map();
        // Loop through each product row from the Excel file
        for (const row of jsonData) {
          const sku = row["PRODUCT_CODE"];
          const productName = row["PRODUCT_NAME_E"];
          const productPrice = row["PRICE"];
          const productUnit = row["ORDER_UNIT"];
          let totalQtyForProduct = 0;

          // Ensure a product entry exists in our map
          if (!itemsForBulkCart.has(sku)) {
            itemsForBulkCart.set(sku, {
              cartItem: {
                sku: sku,
                quote_id: "", // Will be filled in BULKADDTOCART
                qty: 0, // This will be the total quantity for all branches
                price: productPrice,
                extension_attributes: {
                  unit: productUnit,
                },
              },
              splitorder: [],
            });
          }

          // Loop through each branch and add to the splitorder array
          for (const branchName of branchNames) {
            const qty = row[branchName];
            // const deliveryDateColumn = `${branchName} Delivery Date`;
            const deliveryDateColumn = `Delivery Date ${branchName}`;
            const deliveryDate = row[deliveryDateColumn];
            const branchObject = allAddresses?.data?.find(branch => branch?.branch_name === branchName);

            if (qty && qty > 0 && branchObject) {

              let formattedDeliveryDate = null;
              if (deliveryDate instanceof Date) {
                const adjustedDate = new Date(deliveryDate.getTime() + 12 * 60 * 60 * 1000);
                formattedDeliveryDate = adjustedDate.toISOString().split('T')[0];
              }

              // Create a single splitorder object for this branch
              const splitOrderPart = {
                company_id: "", // Will be filled in BULKADDTOCART
                customer_id: "", // Will be filled in BULKADDTOCART
                branch_id: branchObject.address_id,
                product_id: "", // This might not be needed or will be filled later
                item_id: 0,
                qty: qty,
                name: productName,
                sku: sku,
                delivery_date: formattedDeliveryDate,
              };
              itemsForBulkCart.get(sku).splitorder.push(splitOrderPart);
              totalQtyForProduct += qty;
            }
          }

          // Update the total quantity for the product
          itemsForBulkCart.get(sku).cartItem.qty = totalQtyForProduct;
        }

        const bulkCartArray = Array.from(itemsForBulkCart.values());
        if (bulkCartArray?.length > 0) {
          // Pass the fully formatted array to the bulk add function
          // await BULKADDTOCART(bulkCartArray);
          await BULKADDTOCART(dispatch, bulkCartArray, cart, toast, setShowNoAddressModal);
        } else {
          toast.info("No valid items with quantities found in the Excel file.");
        }

      } catch (error) {
        console.error("Error while creating quotations:", error);
        toast.error("Imported excel failed!");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // Export handler for a sample Excel with only a header
  const handleExport = async () => {
    const address = await axios({
      method: "get",
      url: `${request.getbranch}/${localStorage.getItem("userid")}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // 1. Define your header row. It must be an array inside another array.
    const fixedHeaders = ["STATUS", "PRODUCT_CODE", "PRODUCT_NAME_T", "PRODUCT_NAME_E", "ORDER_UNIT", "PRICE"];

    // Create the dynamic part of the header from the branch details
    const dynamicHeaders = address?.data.reduce((acc, branch) => {
      acc.push(branch.branch_name, `Delivery Date ${branch.branch_name}`);
      return acc;
    }, []);

    // Combine the fixed and dynamic headers into one array using the spread (...) syntax
    const finalHeaderRow = [...fixedHeaders, ...dynamicHeaders];

    // Create a worksheet from the final combined header
    const worksheet = XLSX.utils.aoa_to_sheet([finalHeaderRow]);

    // Create the workbook and trigger the download
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Import Template");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Sample Import Template.xlsx");
  };

  useEffect(() => {
    if (localStorage.getItem('userdata') == undefined) {
      history.replace("/login", { from: location.pathname });
    }
  }, [localStorage.getItem('userdata')])

  useEffect(() => {
    const initialRows = cart?.map((el, i) => {
      if (el?.item_selected == "1") {
        return ({ index: i, dataIndex: i })
      }
    })
    setSelectedRows({ rowsSelected: [...initialRows] });
  }, [cart]);

  // OPTIONS FOR DATA TABLE
  const options = {
    filter: false,
    filterType: "dropdown",
    responsive: "standard",
    download: false,
    print: false,
    sort: false,
    pagination: false,
    viewColumns: false,
    search: false,
    selectableRows: "multiple",
    onRowSelectionChange: (rowsSelected, allRows) => {
      console.log(allRows, 'allRows')
      if (!allRows?.length) {
        setSelectedRows({ rowsSelected: [] })
        UpdateRow({ rowsSelected: [] })
      } else {
        setSelectedRows({
          rowsSelected: allRows.map(row => {
            return {
              index: row.index, dataIndex: row.dataIndex
            }
          })
        });
        UpdateRow({
          rowsSelected: allRows.map(row => {
            return {
              index: row.index, dataIndex: row.dataIndex
            }
          })
        });
      }
    },
    textLabels: {
      body: {
        noMatch: (
          <div className="no_data_found">
            <p>{t("No data Found...")}</p>
          </div>
        ),
      },
      pagination: {
        rowsPerPage: t("Rows per page:"),
        displayRows: t("of"),
      },
    },
  }

  const UpdateRow = async (value) => {
    let addid = [];
    let removeid = [];
    value?.rowsSelected?.filter(SR => {
      addid.push(cart[SR?.index]?.item_id)
    })

    cart?.filter(el => {

      if (addid.some(item => el?.item_id?.includes(!item))) {
        removeid.push(el?.item_id)
      }

      if (!value?.rowsSelected?.length) {
        removeid.push(el?.item_id)
      }
    })


    if (addid.length > 0) {
      try {
        await axios({
          method: "post",
          url: request.quoteitemupdate,
          data: {
            cartId: localStorage.getItem("cartid"),
            value: 1,
            itemId: addid,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
      } catch (e) {
        console.log(e);
      }
    }
    if (removeid.length > 0) {
      try {
        await axios({
          method: "post",
          url: request.quoteitemupdate,
          data: {
            cartId: localStorage.getItem("cartid"),
            value: 0,
            itemId: removeid,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
      } catch (e) {
        console.log(e);
      }
    }

    dispatch({
      type: "SET_MEGAMENU_HIDE",
      value: false,
    });
    dispatch({
      type: "CART_STATUS",
    });
  }

  const deletecartitem = async (item_id, sku, name) => {
    try {
      await axios({
        method: "post",
        url: `${request.deletecartitem}${localStorage.getItem("userid")}/${item_id
          }/${sku}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      createlog(name);
      dispatch({
        type: "CART_STATUS",
      });
      await axios({
        method: "post",
        url: request.splitorderdelete,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          data: {
            id: 1,
            customer_id: localStorage.getItem("userid")
          },
        },
      });
    } catch (e) {
      console.log(e)
      // toast.error(e.response?.data?.message);
    }
  };
  // LOGS CREATION - API
  const createlog = async (name) => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      await axios({
        method: "post",
        url: request.newlog,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            company_id: localStorage.getItem("companyid"),
            remote_ip: res.data.IPv4,
            user_agent: `${browserName} Version:${browserVersion}`,
            action: `${JSON.parse(localStorage.getItem("userdata")).firstname
              } deleted ${name} from the cart`,
            action_type: "save",
            functioncall_url: "user/save/",
          },
        },
      });
      await axios({
        method: "post",
        url: request.createnotification,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            company_id: localStorage.getItem("companyid"),
            remote_ip: res.data.IPv4,
            user_agent: `${browserName} Version:${browserVersion}`,
            action_data: `${JSON.parse(localStorage.getItem("userdata")).firstname
              } deleted ${name} from the cart`,
            action_type: "save",
            functioncall_url: "user/save/",
            status: 0,
            category: "notification"
          },
        },
      });
    } catch (e) {
      console.log(e)
      // toast.error(e.response?.data?.message);
    }
  };


  useEffect(() => {
    setUserEmail(localStorage.getItem("user") || "");
    setColumns([
      {
        name: 'name', label: `${t("PRODUCT")}`, options: {
          customBodyRender: (value, tableMeta) => {
            let SKU = tableMeta.rowData?.[6]?.[0]?.sku
            let image = tableMeta.rowData?.[7]
            let product_id = tableMeta?.rowData?.[12]
            let quote = tableMeta?.rowData?.[13]
            let url_key = tableMeta?.rowData?.[14]
            let category_id = tableMeta?.rowData?.[15]
            let order_taking = tableMeta?.rowData?.[16]
            return (
              <div className={`cart__product ${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>
                <p>
                  <img alt="" src={`${request.image}media/catalog/product${image}`}></img>
                  <a href={`/pdp/${!quote ? "catalog" : "product"}/${order_taking == "Y" ? "ordertaking" : "stock"}/${category_id}/${product_id}/${url_key}`}
                    target='_blank'
                  >
                    <span className='cart__product__name'>{value}</span>
                    <span className='cart__product__sku'>{SKU}</span>
                  </a>
                </p>
              </div>
            );
          },
        }
      },
      {
        name: 'price', label: `${t("UNITPRICE")}`, options: {
          customBodyRender: (value) => {
            return (
              <div className={`cart__unitprice ${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>
                <span>฿ {formatToCurrency(parseFloat(value).toFixed(2))}</span>
              </div>
            );
          },
        }
      },
      {
        name: 'qty', label: `${t("QUANTITY")}`, options: {
          customBodyRender: (value, tableMeta) => {
            let name = tableMeta?.rowData?.[0]
            let unit = tableMeta?.rowData?.[5]
            let item_id = tableMeta?.rowData?.[8]
            let qty = tableMeta?.rowData?.[9]
            let sku = tableMeta?.rowData?.[10]
            let quote_id = tableMeta?.rowData?.[11]
            let product_id = tableMeta?.rowData?.[12]
            let delivery_date = tableMeta?.rowData?.[6]?.[0]?.delivery_date
            // return (<div className="loader"></div>);
            return (
              loader ? <div className="loader"></div> :
                <div className={`cart__qty ${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>
                  <span>
                    {/* <img src={Subtract} alt="" onClick={() => minusqty(item_id, qty, sku, quote_id, product_id, name, delivery_date)} /> */}
                    <span className='qty__qty'>{parseInt(value)}</span>
                    {/* <img src={Add} alt="" onClick={() => addqty(item_id, qty, sku, quote_id, product_id, name, delivery_date)} /> */}
                    <span className='qty__unit'>{unit}</span>
                  </span>
                </div>
            );
          },
        }
      },
      {
        name: '', label: `${t("TOTALPRICE")}`, options: {
          customBodyRender: (value, tableMeta) => {
            let price = tableMeta?.rowData?.[1]
            let unit = tableMeta?.rowData?.[2]
            return (
              <div className={`cart__totalprice ${localStorage.getItem('storeid') == 1 ? 'englang' : 'thailang'}`}>
                <span>฿ {formatToCurrency(parseFloat(price * unit).toFixed(2))}</span>
              </div>
            );
          },
        }
      },
      {
        name: '', label: '', options: {
          customBodyRender: (value, tableMeta) => {
            let item_id = tableMeta?.rowData?.[8]
            let sku = tableMeta?.rowData?.[10]
            let name = tableMeta?.rowData?.[0]
            return (
              <div className='cart__delete'>
                <img src={ClearAll} alt="" onClick={() => deletecartitem(item_id, sku, name)} />
              </div>
            )
          }
        }
      },
      {
        name: 'unit', label: '', options: {
          display: false
        }
      },
      {
        name: 'splitorder', label: '', options: {
          display: false
        }
      },
      {
        name: 'image', label: '', options: {
          display: false
        }
      },
      {
        name: 'item_id', label: '', options: {
          display: false
        }
      },
      {
        name: 'qty', label: '', options: {
          display: false
        }
      },
      {
        name: 'sku', label: '', options: {
          display: false
        }
      },
      {
        name: 'quote_id', label: '', options: {
          display: false
        }
      },
      {
        name: 'product_id', label: '', options: {
          display: false
        }
      },
      {
        name: 'quote', label: '', options: {
          display: false
        }
      },
      {
        name: 'url_key', label: '', options: {
          display: false
        }
      },
      {
        name: 'category_id', label: '', options: {
          display: false
        }
      },
      {
        name: 'order_taking', label: '', options: {
          display: false
        }
      },

    ])
    setSubTotal([])
    cart.filter(C => setSubTotal(prevState => [...prevState, C?.price * C?.qty]))
  }, [cart])


  const clearCart = async () => {
    try {
      await axios({
        method: "delete",
        url: `${request.clearcart}/${localStorage.getItem("cartid")}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch({
        type: "CART_STATUS",
      });
    } catch (e) {
      console.log(e)
      // toast.error(e.response?.data?.message);
    }
  };

  const MUITABLEMEMO = useMemo(() => {
    return <MUIDataTable
      data={cart?.length ? cart : []}
      columns={columns}
      options={{
        ...options,
        count: cart?.length,
        rowsSelected: selectedRows?.rowsSelected?.map((row) => row?.index),
      }}
    />
  }, [cart, selectedRows])

  const headingData = {
    title: t('CARTSUMMARY'),
    // backLink: '/MAccount',
    className: 'cart__title',
    isHideHeader: true,
  }

  return (
    <div className='cart'>
      {window.innerWidth > 912 ? <div className='cart__breadcrumbs'>
        <Link to="/">{t("Home")}</Link>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_1_18599)">
            <path d="M10.0199 6L8.60986 7.41L13.1899 12L8.60986 16.59L10.0199 18L16.0199 12L10.0199 6Z" fill="#323232" />
          </g>
          <defs>
            <clipPath id="clip0_1_18599">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span>{t("Cart")}</span>
      </div> : null}
      {/* <h4 className='cart__title'>
      {t("CARTSUMMARY")}</h4> */}
      <div className='excel_col_1'>
        <Heading headingData={headingData} />

        {(SPECIAL_EMAILS.includes(userEmail.toLowerCase().trim())) && (
          <div className='xl_file'>
            <div className='import_xl'>
              {window.innerWidth > 912 ? <label htmlFor="uploadExcel" style={{ cursor: "pointer" }}>
                {t("Import excel file")}
              </label> : <label htmlFor="uploadExcel" style={{ cursor: "pointer" }}>
                {t("Import")}
              </label>}
              <input
                type="file"
                id="uploadExcel"
                accept=".xlsx, .xls"
                style={{ display: "none" }}
                onChange={handleImport}
              />
            </div>
            {window.innerWidth > 912 ? <div className='export_xl' onClick={handleExport}>{t("Export excel file")}</div> :
              <div className='export_xl' onClick={handleExport}>{t("Export")}</div>}
          </div>)}
      </div>


      <div className='cart__content'>
        {window.innerWidth <= 912 && cart?.length > 0 &&
          <p className='cart__clearall'>
            <span onClick={clearCart}>{t("CLEARALL")} ({cart.length})</span>
          </p>
        }
        <div className='cart__left'>
          {MUITABLEMEMO}

          {window.innerWidth > 912 &&
            cart?.length > 0 &&
            <button className='cart__clearall' onClick={clearCart}>
              {t("CLEARALL")}
              <img src={ClearAll} alt="" />
            </button>
          }
        </div>
        <div className='cart__right'>
          <Summary
            label1="Merchandise Subtotal"
            value1={summary?.subtotal}
            label2={`${t("VAT")} (${summary?.tax_amount > 0 ? "7" : "0"}%)`}
            value2={summary?.tax_amount}
            label3="Total Payment"
            value3={summary?.total}
            button={"Checkout"}
            cartlength={cart?.length}
            cart={cart}
          />
        </div>
      </div>

      {/* Add this at the end */}
      <NoAddressModal
        open={showNoAddressModal}
        onClose={() => setShowNoAddressModal(false)}
        t={t}
      />
    </div >
  )
}

export default Cart